//banner滑动
function scrollToCalendar() {
  const targetElement = document.getElementById('calendarContainer');
  if (targetElement) {
    targetElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}
// 等待页面DOM加载完成
document.addEventListener('DOMContentLoaded', function() {
  // 核心函数：隐藏无货产品卡片
  function hideOutOfStockProducts() {
    // 遍历所有产品卡片
    document.querySelectorAll('.product-card').forEach(card => {
      // 检查卡片内是否有禁用的加入购物车按钮（无货标识）
      const addToCartBtn = card.querySelector('.circle-plus[disabled]');
      // 或检查是否有sold-out-btn类（无货样式类）
      const isSoldOut = addToCartBtn || card.querySelector('.sold-out-btn');
      
      // 如果无货，隐藏整个产品卡片
      if (isSoldOut) {
        card.style.display = 'none';
      } else {
        card.style.display = 'block'; // 有货则显示（兼容Tab切换）
      }
    });
  }

  // 初始加载时执行一次
  hideOutOfStockProducts();

  // Tab切换逻辑（如果原有Tab切换无JS，需补充）
  const tabButtons = document.querySelectorAll('.tab-btn');
  const tabPanes = document.querySelectorAll('.tab-pane');

  tabButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      // 移除所有Tab激活状态
      tabButtons.forEach(b => b.classList.remove('active'));
      tabPanes.forEach(p => p.classList.remove('active'));
      
      // 激活当前Tab
      this.classList.add('active');
      const targetTab = document.getElementById(this.dataset.tab);
      targetTab.classList.add('active');

      // Tab切换后重新检查并隐藏无货产品
      setTimeout(hideOutOfStockProducts, 100); // 延迟确保DOM渲染完成
    });
  });

  // 兼容滚动/动态加载场景：监听卡片容器变化（可选）
  const observer = new MutationObserver(hideOutOfStockProducts);
  document.querySelectorAll('.cards-container').forEach(container => {
    observer.observe(container, { childList: true, subtree: true });
  });
});
// function addToCart(variantId) {
//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify({
//       items: [{
//         id: variantId,
//         quantity: 1
//       }]
//     })
//   })
//   .then(response => response.json())
//   .then(data => {
//     console.log('Added to cart:', data);
//     // 可以在这里添加成功提示
//   })
//   .catch(error => {
//     console.error('Error:', error);
//   });
// }
//box2 导航栏
document.addEventListener('DOMContentLoaded', function() {
    // 获取导航元素和目标元素
    const navItems = document.querySelectorAll('.box2_nav div');
    const sections = {
        'Christmas Countdown': document.getElementById('calendarContainer'),
        'Handpick': document.getElementById('Handpick'),
        'Match Everyone’s Power': document.getElementById('Classify')
    };

    // 导航点击事件
    navItems.forEach(item => {
        item.addEventListener('click', function() {
            const text = this.textContent.trim();
            scrollToSection(text);
        });
    });

    // 滚动到指定区域
    function scrollToSection(sectionName) {
        const targetElement = sections[sectionName];
        
        if (targetElement) {
            // 更新导航激活状态
            navItems.forEach(nav => nav.classList.remove('navActive'));
            const activeNav = Array.from(navItems).find(nav => nav.textContent.trim() === sectionName);
            if (activeNav) activeNav.classList.add('navActive');

            // 滚动到目标位置（考虑50px偏移）
            const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - 48;
            
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    }

    // 滚动监听函数
    function updateActiveNavOnScroll() {
        const scrollPosition = window.pageYOffset + 100; // 提前100px触发切换，让体验更流畅
        
        // 找到当前可见的区域
        let currentSection = null;
        
        // 按页面顺序检查每个区域
        const sectionEntries = Object.entries(sections);
        for (let i = sectionEntries.length - 1; i >= 0; i--) {
            const [name, element] = sectionEntries[i];
            if (element && element.offsetTop <= scrollPosition) {
                currentSection = name;
                break;
            }
        }
        
        // 更新导航激活状态
        if (currentSection) {
            navItems.forEach(nav => nav.classList.remove('navActive'));
            const activeNav = Array.from(navItems).find(nav => nav.textContent.trim() === currentSection);
            if (activeNav) activeNav.classList.add('navActive');
        }
    }

    // 添加滚动监听（使用节流优化性能）
    let scrollTimeout;
    function throttleScroll() {
        if (!scrollTimeout) {
            scrollTimeout = setTimeout(function() {
                scrollTimeout = null;
                updateActiveNavOnScroll();
            }, 100);
        }
    }

    window.addEventListener('scroll', throttleScroll);
    
    // 初始化时检查一次
    updateActiveNavOnScroll();
});
// // copy
// function copyText(el, text, event) {
//     event.stopPropagation(); // 阻止事件冒泡（避免触发父元素的点击事件）
//     navigator.clipboard.writeText(text).then(() => {
//         const originalText = el.textContent;  // 保存原始文本（比如"copy"）
//         el.textContent = 'copied';            // 复制成功后，按钮文字改为"copied"
//         setTimeout(() => {
//             el.textContent = originalText;    // 3秒后恢复原始文字
//         }, 3000);
//     })
// }

// box6 切换功能
document.querySelectorAll('.tab-btn').forEach(button => {
  button.addEventListener('click', () => {
    document.querySelectorAll('.tab-btn').forEach(btn => btn.classList.remove('active'));
    button.classList.add('active');
    
    document.querySelectorAll('.tab-pane').forEach(pane => pane.classList.remove('active'));
    document.getElementById(button.getAttribute('data-tab')).classList.add('active');
  });
});


document.addEventListener('DOMContentLoaded', function() {
  // 获取所有卡片容器和按钮
  const cardsContainers = document.querySelectorAll('.cards-container');
  const leftButtons = document.querySelectorAll('.scroll-left');
  const rightButtons = document.querySelectorAll('.scroll-right');
  
  // 为每个容器添加滚动功能
  cardsContainers.forEach((container, index) => {
    const leftBtn = leftButtons[index];
    const rightBtn = rightButtons[index];
    
    if (leftBtn && rightBtn) {
      // 向左滚动
      leftBtn.addEventListener('click', () => {
        const cardWidth = container.querySelector('.card-mold').offsetWidth + 16; // 卡片宽度 + gap
        const scrollDistance = cardWidth * 1; // 滚动2张卡片的距离
        container.scrollBy({
          left: -scrollDistance,
          behavior: 'smooth'
        });
      });
      
      // 向右滚动
      rightBtn.addEventListener('click', () => {
        const cardWidth = container.querySelector('.card-mold').offsetWidth + 16; // 卡片宽度 + gap
        const scrollDistance = cardWidth * 1; // 滚动2张卡片的距离
        container.scrollBy({
          left: scrollDistance,
          behavior: 'smooth'
        });
      });
      
      // 根据滚动位置显示/隐藏按钮
      const updateButtonVisibility = () => {
        const scrollLeft = container.scrollLeft;
        const scrollWidth = container.scrollWidth;
        const clientWidth = container.clientWidth;
        
        // 隐藏左按钮当滚动到最左边
        leftBtn.style.opacity = scrollLeft <= 0 ? '0.5' : '1';
        leftBtn.style.cursor = scrollLeft <= 0 ? 'not-allowed' : 'pointer';
        
        // 隐藏右按钮当滚动到最右边
        rightBtn.style.opacity = scrollLeft + clientWidth >= scrollWidth - 1 ? '0.5' : '1';
        rightBtn.style.cursor = scrollLeft + clientWidth >= scrollWidth - 1 ? 'not-allowed' : 'pointer';
      };
      
      // 监听滚动事件
      container.addEventListener('scroll', updateButtonVisibility);
      
      // 初始更新按钮状态
      updateButtonVisibility();
    }
  });
});

 document.addEventListener('DOMContentLoaded', function() {
            // 覆盖图片功能
            function initCoverImages() {
                const box4Cover = document.querySelector('.box4 .cover-image');
                const box5Cover = document.querySelector('.box5 .cover-image');
                
                if (!box4Cover || !box5Cover) return;
                
                let box4Visible = false;
                let box5Visible = false;
                 // box4的覆盖图片控制（立即开始）
                setInterval(() => {
                    box4Visible = !box4Visible;
                    if (box4Visible) {
                        box4Cover.classList.add('active');
                    } else {
                        box4Cover.classList.remove('active');
                    }
                }, 6000); // 每6秒切换一次（显示3秒 + 隐藏3秒）
                
                // box5的覆盖图片控制（延迟3秒开始，与box4错开）
                setTimeout(() => {
                    setInterval(() => {
                        box5Visible = !box5Visible;
                        if (box5Visible) {
                            box5Cover.classList.add('active');
                        } else {
                            box5Cover.classList.remove('active');
                        }
                    }, 6000); // 每6秒切换一次（显示3秒 + 隐藏3秒）
                }, 3000); // 延迟3秒开始

                  // 初始状态：box4立即显示，box5等待
                setTimeout(() => {
                    box4Cover.classList.add('active');
                    box4Visible = true;
                }, 100);
            }
                   // 复制功能
            function copyText(element, text, event) {
                event.preventDefault();
                navigator.clipboard.writeText(text).then(() => {
                    const originalText = element.textContent;
                    element.textContent = 'Copied!';
                    setTimeout(() => {
                        element.textContent = originalText;
                    }, 3000);
                });
            }
            
            window.copyText = copyText;
            
            // 初始化覆盖图片功能
            initCoverImages();
        });
            